import { render, staticRenderFns } from "./CurationRequestModal.vue?vue&type=template&id=073b3527&scoped=true"
import script from "./CurationRequestModal.vue?vue&type=script&lang=js"
export * from "./CurationRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073b3527",
  null
  
)

export default component.exports